module.exports = __webpack_public_path__ + "img/kr-product-footer-icon.4f6abb3.png";